
<div :class="classes(n(), n(`--${background}`))">
  <div :class="classes(n('inner'))">
    <!-- 左/右始终渲染；量测后两侧同宽，保证标题几何居中 -->
    <div
      ref="leftRef"
      :class="classes(n('left'))"
      :style="sideStyle"
      :role="showLeft ? 'button' : undefined"
      aria-merge="true"
      aria-label="back"
      @click="onClickLeft"
    >
      <template v-if="showLeft">
        <slot
          v-if="$slots.left"
          name="left"
        />
        <ArrowLeftOIcon
          v-else
          width="24"
          height="48"
          :class="classes(n('left-icon'))"
        />
      </template>
    </div>

    <div :class="classes(n('center'))">
      <span :class="classes(n('title'))">{{ title }}</span>
    </div>

    <div
      ref="rightRef"
      :class="classes(n('right'))"
      :style="sideStyle"
      :role="showRight ? 'button' : undefined"
      aria-merge="true"
      @click="onClickRight"
    >
      <slot
        v-if="showRight"
        name="right"
      />
    </div>
  </div>
</div>
